export default __webpack_public_path__ + "static/media/PPI-firefeature-012.7ee8c5ac.jpg";